import { notification } from '@ali/aps';

const RuleContent = ({ content }) => {
  return (
    <div>
      {content}
      <div className="rule-background">
        <img className="left" src="https://img.alicdn.com/tfs/TB16SHZiAvoK1RjSZPfXXXPKFXa-268-522.png" />
        <img className="right" src="https://img.alicdn.com/tfs/TB10QD1iyrpK1RjSZFhXXXSdXXa-256-300.png" />
        <img className="top" src="https://img.alicdn.com/tfs/TB1iNj0iCzqK1RjSZFHXXb3CpXa-168-124.png" />
      </div>
    </div>
  );
};

const createMarkup = html => ({ __html: html });

async function ruleToast({ title, text }) {
  const content = <RuleContent content={<div dangerouslySetInnerHTML={createMarkup(text)} />} />;
  notification.alert(content, { title, buttons: [], className: 'rule' });
}

export default ruleToast;



// WEBPACK FOOTER //
// ./src/scripts/utils/notification/ruleToast.js